import { Form, Input } from 'decorator-form';

import { IBreakpoint } from 'common/form/fields/BreakpointsField';
import InputType from 'common/form/InputType';

@Form({title: "Rows View Config"})
export default class RowsConfig {

	@Input({type: InputType.NUMBER, title: "Default Items Per Row"})
	public columns: number = 1;

	@Input({type: InputType.BREAKPOINTS, title: "Responsive Breakpoints"})
	public breakpoints: IBreakpoint[] = [];

	@Input({type: InputType.NUMBER, title: "Items per column"})
	public itemsPerColumn?: number;

	@Input({type: InputType.UNIT, title: "Gutter Spacing"})
	public padding?: string;

	@Input({type: InputType.NUMBER, title: "Default sleleton items (active before the 1st render"})
	public defaultSkeletonCount?: number = 6;

}



// WEBPACK FOOTER //
// ./src/common/views/rows/RowsConfig.ts